import { useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';

export default function useStats(props) {
    return useConnector(connectStats, props);
}